var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("../../assets/images/seckill/loading.gif"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.$t('seckillLimit.moment')))])])}
var staticRenderFns = []

export { render, staticRenderFns }